import React, { useState, useEffect } from "react";
import ModalCita from "./ModalCita"; // Asegúrate de importar el modal correcto
import "./MonthView.css";
import { getCitas } from "../../../../../services/citas";


const MonthView = ({ selectedDate, onDateChange, setActiveView, refresh, setRefresh }) => {
 
  const daysOfWeek = ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"];
  const [mostrarModal, setMostrarModal] = useState(false);
  const [citaSeleccionada, setCitaSeleccionada] = useState(null);
  const [citas, setCitas] = useState([]);

  // Cargar las citas del mes (se actualiza si selectedDate o refresh cambian)
  useEffect(() => {
    const fetchCitas = async () => {
      try {
        const data = await getCitas();
        const year = selectedDate.getFullYear();
        const month = selectedDate.getMonth() + 1; // Mes en formato 1-indexado
        const citasMonth = data.filter((cita) => {
          const [cYear, cMonth] = cita.fecha.split("-").map(Number);
          return cYear === year && cMonth === month;
        });
        setCitas(citasMonth);
      } catch (error) {
        console.error("Error al obtener citas:", error);
      }
    };
    fetchCitas();
  }, [selectedDate, refresh]);

  // Generar la cuadrícula del mes con las citas en cada día
  const generateDaysInMonth = (date) => {
    const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const startDayIndex = firstDayOfMonth.getDay(); // 0 (Domingo) a 6 (Sábado)
    const daysInMonth = lastDayOfMonth.getDate();

    const days = [];
    // Rellenar celdas vacías antes del primer día
    for (let i = 0; i < startDayIndex; i++) {
      days.push({ day: null, citas: [] });
    }
    // Agregar los días del mes
    for (let i = 1; i <= daysInMonth; i++) {
      const dayStr = i.toString().padStart(2, "0");
      const monthStr = (date.getMonth() + 1).toString().padStart(2, "0");
      const dateStr = `${date.getFullYear()}-${monthStr}-${dayStr}`;
      const citasDelDia = citas.filter((cita) => cita.fecha === dateStr);
      days.push({
        day: i,
        citas: citasDelDia,
        isToday:
          new Date().toDateString() ===
          new Date(date.getFullYear(), date.getMonth(), i).toDateString(),
      });
    }
    return days;
  };

  const days = generateDaysInMonth(selectedDate);

  // Abrir el modal de "Nueva Cita" para un día determinado
  const abrirModalNuevaCita = (dia) => {
    if (!dia) return;
    const fechaSeleccionada = new Date(
      selectedDate.getFullYear(),
      selectedDate.getMonth(),
      dia
    ).toLocaleDateString("en-CA"); // Formato YYYY-MM-DD
    setCitaSeleccionada({
      fecha: fechaSeleccionada,
      start_time: "",
      end_time: "",
      motivo: "",
      paciente: "",
    });
    setMostrarModal(true);
  };

  const irADiaConCitas = (event, dia) => {
  event.stopPropagation();

  if (!dia) return;

  const nuevaFecha = new Date(
    selectedDate.getFullYear(),
    selectedDate.getMonth(),
    dia
  );

  onDateChange(nuevaFecha);
  setActiveView("day");
  };
  

  return (
    <div className="month-view">
      <div className="month-header">
        {daysOfWeek.map((day, index) => (
          <div key={index} className="month-day-header">
            {day}
          </div>
        ))}
      </div>
      <div className="month-body">
        {days.map((cell, index) => (
          <div
            key={index}
            className={`month-day-cell ${
              cell.isToday ? "month-today" : ""
            } ${!cell.day ? "empty-cell" : ""}`}
            onClick={() => abrirModalNuevaCita(cell.day)}
          >
            {cell.day && (
              <>
                <div className="month-day-number">{cell.day}</div>
                  {cell.citas.filter(cita => cita.status !== "cancelada").length > 0 && (
                  <div
                    className="citas-count"
                    onClick={(event) => irADiaConCitas(event, cell.day)}
                  >
                    {cell.citas.filter(cita => cita.status !== "cancelada").length}
                    {cell.citas.filter(cita => cita.status !== "cancelada").length === 1 ? " Cita" : " Citas"}
                  </div>
                )}
              </>
            )}
          </div>
        ))}
      </div>
      {mostrarModal && (
        <ModalCita
          cita={citaSeleccionada}
          onGuardar={() => {setMostrarModal(false); setRefresh((prev) => !prev); }}
          onEliminar={() => {setMostrarModal(false); setRefresh((prev) => !prev);}}
          onCerrar={() => setMostrarModal(false)}
        />
      )}
    </div>
  );
};

export default MonthView;
